/* global slides:writable prevSlide completeSlide nextSlide jumpToId globalVar Howler Howl */
var siAudio = {};

function initAudio() {
	siAudio.sfx = {};
	siAudio.sfx.click = new Howl({
		src: ['media/audio/sounds/mouse_click.mp3'],
		volume: 0.8
	});

	siAudio.sfx.wrong = new Howl({
		src: ['media/audio/sounds/negative.mp3'],
		volume: 0.5
	});
	siAudio.sfx.right = new Howl({
		src: ['media/audio/sounds/positive.mp3'],
		volume: 0.5
	});
	siAudio.sfx.nothing = new Howl({
		src: ['media/audio/sounds/nothing.mp3']
	});

	for (var key in slides) {
		if (slides[key].audio && Object.keys(slides[key].audio).length > 0) {
			siAudio[key] = {};
			var audio = slides[key].audio;
			for (var track in audio) {
				siAudio[key][track] = new Howl({
					src: audio[track]
				});
			}
		} else {
			slides[key].audio = {};
		}

		if (slides[key].hotspot && slides[key].hotspot.audio && Object.keys(slides[key].hotspot.audio).length > 0) {
			if (siAudio[key] === undefined) {
				siAudio[key] = {};
			}
			var hotspotAudio = slides[key].hotspot.audio;
			for (var hotspotTrack in hotspotAudio) {
				siAudio[key][hotspotTrack] = new Howl({
					src: hotspotAudio[hotspotTrack]
				});
			}
		}
	}

	for (var audioGroup in siAudio) {
		for (var sound in siAudio[audioGroup]) {
			var audioTrack = siAudio[audioGroup][sound];
			audioTrack.initialVolume = audioTrack._volume;
		}
	}
}
